<div class="container py-5">
    <div class="row gx-lg-5">
        @for ( partner of body?.items; track $index; let odd = $odd) {
        <div class="col-md-6 col-xl-4 mt-5 mt-lg-6" appAos>
            <a [href]="partner?.link?.url" target="_blank" rel="noopener nofollow">
                <div class="position-relative scale-on-hover">
                    <img
                        [src]="partner?.image?.url"
                        [alt]="partner?.image?.alt"
                        [title]="partner?.image?.url"
                        class="w-100 mb-4 work rounded-4"
                    />
                </div>
                <p class="heading mb-1">{{ partner?.heading }}</p>
                <p class="text-size-m color-black mb-3">{{ partner?.title }}</p>
                <div [innerHTML]="partner?.description | renderHtml"></div>
            </a>
        </div>
        }
    </div>
</div>
